import Component from '@bythepixel/component-loader';
import { windowMatchMedia } from '@Constants';

const selectors = {
  toggleBtn: '[data-profile-menu-toggle]',
  menuContainer: '[data-profile-menu-container]',
  menuLink: '[data-profile-menu-link]',
  activeClass: 'profile-menu__container--active'
};

export default class ProfileMenu extends Component {
  static selector = '[data-comp-profile-menu]'
  static loaderPriority = 'in-view';

  #state = {
    disableScroll: false,
  }

  constructor(containerEl) {
    super(containerEl);
    this.toggleBtn = this.$container.querySelector(selectors.toggleBtn);
    this.menuContainer = this.$container.querySelector(selectors.menuContainer);
    this.activeClass = selectors.activeClass;
    this.addToggleButtonListener();
  }

  addToggleButtonListener() {
    this.toggleBtn.addEventListener('click', () => {
      if (this.menuContainer.classList.contains(this.activeClass)) {
        this.closeProfileMenu();
      } else {
        this.openProfileMenu();
      }
    });
  }

  addWindowClickListener() {
    this.windowClickListener = this.windowClickListener.bind(this);
    window.addEventListener('click', this.windowClickListener);
  }

  removeWindowClickListener() {
    window.removeEventListener('click', this.windowClickListener);
  }

  windowClickListener(event) {
    if (!event.target.matches(selectors.menuContainer)
        && !event.target.matches(selectors.toggleBtn)
        && !event.target.matches(selectors.menuLink)
    ) {
      this.closeProfileMenu();
    }
  }

  openProfileMenu() {
    this.menuContainer.classList.add(this.activeClass);
    if (!windowMatchMedia['bp-medium'].matches) {
      this.#state.disableScroll = true;
    }
    this.toggleBodyScroll();
    this.addWindowClickListener();
  }

  closeProfileMenu() {
    this.menuContainer.classList.remove(this.activeClass);
    this.#state.disableScroll = false;
    this.toggleBodyScroll();
    this.removeWindowClickListener();
  }

  toggleBodyScroll() {
    if (this.#state.disableScroll) {
      Object.assign(document.body.style, {
        position: 'fixed',
        height: '100%',
        width: '100%',
      });
    } else {
      Object.assign(document.body.style, {
        position: null,
        height: null,
        width: null,
      });
    }
  }
}
